const mainProjects = [
  {
    id: 1,
    title: "Miu Station Store",
    url: "https://miustationstore.netlify.app/",
    desc:
      "E-Commerce website with private admin route and RESTful API for products management",
    tech: ["Next.js", "MongoDB", "Netlify"],
    git: "https://github.com/PaoloCatalano/Miu_Station_Store",
  },
  {
    id: 2,
    title: "Robertaebasta UK",
    url: "https://robertaebasta.netlify.app",
    desc:
      "London Art Gallery with a huge collection of masterpieces and an automatic generated details page for each article",
    tech: ["Gatsby.js", "Contentful", "Netlify"],
    git: "https://github.com/PaoloCatalano/robertaebastalondon",
  },
  {
    id: 3,
    title: "Alex Television",
    url: "https://alextv.netlify.app",
    desc:
      "Small project implementing serverless functions and YouTube API for selected videos in the lost world of the 80s TV",
    tech: ["Gatsby functions", "API", "Netlify"],
    git: "https://github.com/PaoloCatalano/alextv",
  },
]

export default mainProjects
